import { z } from "zod";

/** Shared shape for promote / marketing asset forms. Caption and alt text are optional. */
export const marketingAssetFormBaseSchema = z.object({
  caption: z.string(),
  altText: z.string(),
  aiObservations: z.array(z.string()),
  visibilityWarnings: z.array(z.string()),
  tags: z.array(z.number()),
  temporalTagId: z.number({ error: "Temporal classification is required" }),
  isRestricted: z.boolean(),
  restrictionReason: z.string().nullable(),
});

export type MarketingAssetFormData = z.infer<typeof marketingAssetFormBaseSchema>;

/** Promote flow: at least one solution tag is always required. */
export function createPromoteMarketingAssetSchema(solutionTagIds: ReadonlySet<number>) {
  return marketingAssetFormBaseSchema
    .refine(
      (data) => data.tags.some((id) => solutionTagIds.has(id)),
      { message: "Select at least one solution tag", path: ["tags"] },
    )
    .refine(
      (data) => !data.isRestricted || (data.isRestricted && data.restrictionReason),
      {
        message: "Restriction reason is required when restricted",
        path: ["restrictionReason"],
      },
    );
}
